import axios from "axios";

const state = {
  otpCalls: [],
  otpCallsMeta: {},
  stats: {},
};

const getters = {
  getOTPCalls: (state) => state.otpCalls,
  getOTPCallsMeta: (state) => state.otpCallsMeta,
  getOTPStats: (state) => state.stats,
};

const actions = {
  async fetchOTPCallResults({ commit }, params) {
    try {
      const response = await axios.get("/otp-calls", { params });
      commit("setOTPCalls", response.data.data);
      commit("setOTPCallsMeta", response.data.meta);
      return response.data;
    } catch (error) {
      console.error("Error fetching OTP calls:", error);
      throw error;
    }
  },

  async fetchOTPStatistics({ commit }) {
    try {
      const response = await axios.get("/otp-calls/stats");
      if (response.data && response.data.meta) {
        commit("setOTPStats", response.data.meta);
        return response.data.meta;
      }
    } catch (error) {
      console.error("Error fetching OTP stats:", error);
      throw error;
    }
  },
};

const mutations = {
  setOTPCalls(state, data) {
    state.otpCalls = data;
  },
  setOTPCallsMeta(state, meta) {
    state.otpCallsMeta = meta;
  },
  setOTPStats(state, stats) {
    state.stats = stats;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
